/* eslint-disable */
import { useAtom } from "jotai";
import { pageContainerWithOverflow } from "../../shared/styles";
import globalState from "../../store";
import DomainInfo from "./components/DomainInfo";
import Layout from "./components/Layout";
import CheckoutLink from "./components/CheckoutLink/CheckoutLink";
import CustomerInfo from "./components/CustomerInfo/CustomerInfo";
import ParkCustomerWebsite from "./components/ParkCustomerWebsite";
import ScheduleSocialPost from "./components/ScheduleSocialPost";
import CustomerSegment from "./components/CustomerSegment";
import { Industry } from "./components/Industry";
import { Redirects } from "./components/Redirects";
import GBPValidationHistory from "./components/GBPValidationHistory";

export default function DomainPage() {
  const [globalStateAtom] = useAtom(globalState);
  const { slug, publish_to_google_storage } = globalStateAtom;

  return (
    <div>
      <div
        className={`${pageContainerWithOverflow} grid grid-cols-2 space-x-6`}
      >
        <div className="w-full">
          <DomainInfo />
          <CustomerInfo />
          <Layout />
        </div>
        <div className="flex flex-col">
          <CheckoutLink />
          <CustomerSegment />
          <Industry />
          <GBPValidationHistory slug={slug} />

          <ParkCustomerWebsite />
          <ScheduleSocialPost />
        </div>
      </div>
      {publish_to_google_storage && (
        <div className={pageContainerWithOverflow}>
          <Redirects />
        </div>
      )}
    </div>
  );
}
